import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router'

import { isAuthenticated } from '@/resources/services/permission/auth'

const Login = lazy(() => import('../pages/Login'))
const RecoverPassword = lazy(() => import('../pages/RecoverPassword'))
const SignUpPage = lazy(() => import('../pages/SignUpPage'))
const RegisterConfirmed = lazy(() => import('../pages/RegisterConfirmed'))
const LandingPagePDV = lazy(() => import('../pages/LandingPagePDV'))

export const publicRoutes: RouteObject[] = [
  {
    path: 'login',
    element: isAuthenticated() ? <Navigate to="/poc-orders" /> : <Login />,
  },
  {
    path: 'recover',
    element: <RecoverPassword />,
  },
  {
    path: 'cadastro-parceiro',
    children: [
      {
        index: true,
        element: <LandingPagePDV />,
      },
      {
        path: 'formulario',
        element: <SignUpPage />,
      },
      {
        path: 'sucesso',
        element: <RegisterConfirmed />,
      },
    ],
  },
]
